







import { Vue, Component, Prop } from 'vue-property-decorator';
import { IBankId } from '@signing-page/signing/types/bankid';

@Component
export default class BankIdError extends Vue {
  @Prop() error: string;
  @Prop() bankId: IBankId;
}
